import React, { PureComponent } from 'react';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom'
import { FormattedMessage } from 'react-intl';
import { Cloak, getCloakCert } from 'cloak-file-sdk-web'
import CloakSnackBar from '../components/ui/CloakSnackBar'

import { styled } from '@mui/system';
import { webServicesUtil, CloakUtilService } from 'cloak-file-sdk-web'

const StyledNavLink = styled(NavLink)(({ theme }) => ({
    color: '#1aa3ff',
    textDecoration: 'underline',
    transition: 'color 0.2s ease',
    '&:hover': {
        color: '#1792e5',
        '@media (hover: none)': {
            color: '#1792e5',
        },
    },
}));

class CloakingPage extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            showSnackBar: false
        }

        this.handleSnackBar = this.handleSnackBar.bind(this)
        this.closeSnackBar = this.closeSnackBar.bind(this)
    }

    handleSnackBar() {
        this.setState({ showSnackBar: true })
    }

    closeSnackBar() {
        this.setState({ showSnackBar: false })
    }

    componentDidMount() {
        console.log("In CloakingPage componentDidMount")
        CloakUtilService().checkInactivityLogout(this.props)
        let intervalId = CloakUtilService().periodicSolicitationRefresh(this.props)
        console.log("In CloakingPage componentDidMount intervalId " + intervalId)
        this.setState({ intervalId: intervalId })
    }

    componentWillUnmount() {
        console.log("In CloakingPage componentWillUnmount intervalId " + this.state.intervalId)
        CloakUtilService().stopPeriodicSolicitationRefresh(this.state.intervalId)
    }

    render() {
        const { redirect, isUser, acceptedClkFile } = this.props;

        if (acceptedClkFile) {
            return <Navigate to="/cloak/uncloak" />
        }

        if (redirect) {
            if (isUser) {
                return <Navigate to="/cloak/login" />
            } else {
                return <Navigate to="/cloak/signup" />
            }

        }

        const { processMessage } = this.props;
        const hsmNotProvisioned = processMessage === 'cloak.hsmCertNotProvisioned';

        return (
            <div className="clk-primary-console-div">
                {
                    this.state.showSnackBar &&
                    <CloakSnackBar>
                        <div id="link-container">
                            <span id="spacer"></span>
                            <StyledNavLink to="/cloak/qr">
                                <FormattedMessage id="cloak.mobile" values={{ process: 'Cloaking' }} />
                            </StyledNavLink>
                            <span id="spacer"></span>
                            <a href="#" onClick={this.closeSnackBar}>x</a>
                        </div>
                    </CloakSnackBar>
                }
                { hsmNotProvisioned &&
                    <div style={{ margin: '16px auto', maxWidth: 560, padding: '16px 20px', background: '#fff8e1', border: '1px solid #f0a500', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16 }}>
                        <span style={{ fontSize: 14, color: '#5a3e00' }}>
                            <FormattedMessage id="cloak.hsmCertNotProvisioned" />
                        </span>
                        <button
                            onClick={() => this.props.dispatch(getCloakCert())}
                            style={{ whiteSpace: 'nowrap', padding: '6px 16px', background: '#1aa3ff', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 14 }}>
                            <FormattedMessage id="cloak.retry" />
                        </button>
                    </div>
                }
                <div className="clk-primary-console clk-box-shadow ">
                    <div>
                        <div style={{ marginTop: 40 }}>
                            <div className="clk-main-title-div">
                                <div className="clk-main-title-text">
                                    <FormattedMessage id="cloak.cloakFile" />
                                </div>
                            </div>
                        </div>
                        <Cloak onDrop={this.handleSnackBar} algo={webServicesUtil().getCloakFileKeyType()} acceptedFile={this.props.acceptedFile} />
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        redirect: state.cloak.redirect,
        isUser: state.cloak.isUser,
        token: state.auth.token,
        acceptedClkFile: state.cloak.acceptedClkFile,
        acceptedFile: state.cloak.acceptedFile,
        processMessage: state.cloak.processMessage
    }
};

export default connect(mapStateToProps)(CloakingPage);
